import { render, staticRenderFns } from "./Footers.vue?vue&type=template&id=3ee8b5b0&scoped=true&"
import script from "./Footers.vue?vue&type=script&lang=js&"
export * from "./Footers.vue?vue&type=script&lang=js&"
import style0 from "./Footers.vue?vue&type=style&index=0&id=3ee8b5b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ee8b5b0",
  null
  
)

export default component.exports